import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfTitle from '@elem/ui/ef-title';
import { useMemo, useState } from 'react';

// 电池
const Battery = ({ power }: any) => (
    <svg className="phone-battery" xmlns="http://www.w3.org/2000/svg" width="69" height="34" viewBox="0 0 69 34" fill="none">
        <path d="M68.5 16.5C68.5 18.7021 66.7895 20.56 64.7815 21.4144V11.3262C66.7895 12.1806 68.5 14.2979 68.5 16.5Z" fill="black" />
        <rect
            x="4"
            y="4"
            width={(54 * power) / 100}
            height="26"
            rx="5"
            fill="#1CBC24"
            style={{
                transition: 'width 0.5s ease-in-out',
                WebkitTransition: 'width 0.5s ease-in-out',
            }}
        />
        <rect x="1" y="1" width="61" height="32" rx="5" stroke="black" stroke-width="2" />
    </svg>
);

export default function TheComp() {
    const { t } = useLang('rapid.O2');
    const list = [
        {
            label: t('tab1'),
            value: 'wireless',
            data: [
                {
                    name: 'iphone16',
                    power: 90,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258795/16.png',
                },
                {
                    name: 'iphone16 Pro',
                    power: 88,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258174/16Pro.png',
                },
                {
                    name: 'iphone16 Pro Max',
                    power: 67,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743142160924/16ProMax.png',
                },
                {
                    name: 'iphone15',
                    power: 95,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143257998/15.png',
                },
                {
                    name: 'iphone15 Pro',
                    power: 90,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258435/15Pro.png',
                },
                {
                    name: 'iphone15 Pro Max',
                    power: 73,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258611/15ProMax.png',
                },
            ],
        },
        {
            label: t('tab2'),
            value: 'wire',
            data: [
                {
                    name: 'iphone16',
                    power: 100,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258795/16.png',
                },
                {
                    name: 'iphone16 Pro',
                    power: 98,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258174/16Pro.png',
                },
                {
                    name: 'iphone16 Pro Max',
                    power: 75,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743142160924/16ProMax.png',
                },
                {
                    name: 'iphone15',
                    power: 100,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143257998/15.png',
                },
                {
                    name: 'iphone15 Pro',
                    power: 100,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258435/15Pro.png',
                },
                {
                    name: 'iphone15 Pro Max',
                    power: 91,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258611/15ProMax.png',
                },
            ],
        },
    ];
    const [active, setActive] = useState(list[0].value);
    const data = useMemo(() => list.find((item) => item.value === active)?.data || [], [active]);

    return (
        <div className={css.comp} id="O2">
            <EfTitle>{t('title')}</EfTitle>
            <div className="container">
                <div className="desc">{active === list[0].value ? t('desc') : t('desc2')}</div>
                <div className="phone-config">
                    <div className="phone-list">
                        {data.map((item) => (
                            <div className="phone-info" key={item.name}>
                                <div className="phone-top">
                                    <img className="phone-img" src={item.img} alt="" />
                                    <div className="flex flex-col justify-between">
                                        <div>
                                            <span className="phone-power">{item.power}</span>
                                            <span className="phone-percent">%</span>
                                        </div>
                                        <Battery power={item.power} />
                                    </div>
                                </div>
                                <span className="phone-name">{item.name}</span>
                            </div>
                        ))}
                    </div>

                    <div className="tabs">
                        {list.map((item, idx) => (
                            <div className={`tab-item ${active === item.value ? 'active' : ''}`} key={item.value + idx} onClick={() => setActive(item.value)}>
                                {item.label}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <EfImg
                className="bg"
                pc="https://websiteoss.ecoflow.com/upload/image/1743145010595/rapid-pc.png"
                pad="https://websiteoss.ecoflow.com/upload/image/1743145010423/rapid-h5.png"
                h5="https://websiteoss.ecoflow.com/upload/image/1743145010423/rapid-h5.png"
            />
        </div>
    );
}
